export default Object.freeze({
    BANK_TRANSFER: 3,
    PAYPAL: 8,
    BITCOIN: 17,
});
